import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Debug logging
    console.log('Login attempt:', credentials);
    console.log('Username length:', credentials.username.length, 'Value:', credentials.username);
    console.log('Password length:', credentials.password.length, 'Value:', credentials.password);

    // Simple authentication (in production, use proper backend authentication)
    const validCredentials = [
      { username: 'Nikalai11', password: 'Chanel11£' },
      { username: 'Shota', password: 'Shotiko19' }
    ];
    
    console.log('Checking against valid credentials:', validCredentials);
    
    const isValidUser = validCredentials.some(cred => {
      const usernameMatch = credentials.username.trim() === cred.username;
      const passwordMatch = credentials.password.trim() === cred.password;
      console.log(`Checking ${cred.username}: username=${usernameMatch}, password=${passwordMatch}`);
      return usernameMatch && passwordMatch;
    });
    
    console.log('Is valid user:', isValidUser);
    
    if (isValidUser) {
      console.log('Login successful! Redirecting...');
      try {
        localStorage.setItem('ntf_admin_token', 'authenticated');
        console.log('Token set in localStorage');
        setTimeout(() => {
          navigate('/shesvla/dashboard');
          console.log('Navigation triggered');
        }, 100);
      } catch (err) {
        console.error('Error during login process:', err);
        setError('خطأ في عملية تسجيل الدخول');
      }
    } else {
      console.log('Login failed - credentials do not match');
      setError('არასწორი მომხმარებლის სახელი ან პაროლი');
    }
    
    setIsLoading(false);
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  return (
    <motion.div 
      className="admin-login"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="login-container">
        <motion.div 
          className="login-card"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <div className="login-header">
            <div className="login-logo">🔐</div>
            <h1 className="login-title">NTF ადმინისტრაცია</h1>
            <p className="login-subtitle">სისტემაში შესვლა</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username" className="form-label">
                მომხმარებლის სახელი
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={credentials.username}
                onChange={handleChange}
                className="form-input"
                placeholder="შეიყვანეთ მომხმარებლის სახელი"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                პაროლი
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                className="form-input"
                placeholder="შეიყვანეთ პაროლი"
                required
              />
            </div>

            {error && (
              <motion.div 
                className="error-message"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
              >
                {error}
              </motion.div>
            )}

            <motion.button
              type="submit"
              className="login-button"
              disabled={isLoading}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {isLoading ? 'შესვლა...' : 'შესვლა'}
            </motion.button>
          </form>

          <div className="login-footer">
            <p className="footer-text">
              NTF Sports Betting Platform
            </p>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default AdminLogin;